export const SET_PROFILE       = '[PROFILE] Set'

import { createAction, props } from '@ngrx/store';

export const setUserProfile = createAction( SET_PROFILE , props<{userProfile: any}>());
